import { render } from "./ClaimHistorySearch.vue?vue&type=template&id=231e40e8&ts=true"
import script from "./ClaimHistorySearch.vue?vue&type=script&lang=ts"
export * from "./ClaimHistorySearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__